import {SizeContentType} from '../reducers/sizeContent';
import {SIZE_CONTENT_TYPE} from './../type/index';

export const changeSizeContent = (data: SizeContentType) => ({
  type: SIZE_CONTENT_TYPE.CHANGE_SIZE,
  payload: data,
})
